export const subComponents = (translations) => [
    { name: translations["printing_queue"] || "Printer queue", path: '/printer-queue', permissions: ['print_job_list'] },
    { name: translations["users_activities"] || "Users activities", path: '/user-activity', permissions: ['user_session_list'] },
]
